import React, { useId } from 'react';

const Icon = ({ width = '55', height = '48', fill = '#FFEFBC', ...other }) => {
    const id = useId();
    const gradientA = `ecoCreditsIcon-gradient-a-${id}`;

    return (
        <svg width={width} height={height} viewBox="0 0 55 48" fill="none" {...other}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.564 14.03 39.438 1.074a1 1 0 0 1 1.307.56l4.88 12.396M1 15.03a1 1 0 0 1 1-1h50.5a1 1 0 0 1 1 1v7c-3.936 0-7.875 2.667-7.875 7.334s3.939 8.67 7.875 8.67v7a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-7c3.939 0 7.875-2.667 7.875-8.002 0-5.335-3.939-8.001-7.875-8.001V15.03Zm17.061 11.514h7.878-7.878Zm0 8h18.378-18.378Z"
                fill={fill}
            />

            <path
                d="M7.564 14.03 39.438 1.074a1 1 0 0 1 1.307.56l4.88 12.396M18.061 26.544h7.878m-7.878 8h18.378M53.5 22.032V15.03a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v7c3.936 0 7.875 2.667 7.875 8.002 0 5.335-3.936 8.001-7.875 8.001v7.001a1 1 0 0 0 1 1h50.5a1 1 0 0 0 1-1v-7c-3.936 0-7.875-4.003-7.875-8.67s3.939-7.333 7.875-7.333Z"
                stroke={`url(#${gradientA})`}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <defs>
                <linearGradient id={gradientA} x1="50.583" y1="13.585" x2="9.75" y2="44.21" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />

                    <stop offset="0.625" stopColor="#CC9856" />

                    <stop offset="1" stopColor="#C28A48" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
